import { calendarConstants } from '../../_constants';
import { calendarService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const calendarActions = {
    createHoliday,
    createWorkDays,
    getAllHoliday,
    getHoliday,
    getAllWorkingDays,
    getWorkingDayByBranch,
    updateHoliday,
    updateWorkingDays,
    deleteHoliday,
    deleteWorkingDays,
    readLocalHolidaybyBranch,
};

function calendarFetched() { return { type: calendarConstants.CALENDAR_FETCHED } }
function calendarFetching() { return { type: calendarConstants.CALENDAR_FETCHING } }

function calendarSubmitted() { return { type: calendarConstants.CALENDAR_SUBMITTED } }
function calendarSubmitting() { return { type: calendarConstants.CALENDAR_SUBMITTING } }

function readLocalHolidaybyBranch(branch) {
    return dispatch => {
        dispatch(calendarFetching());
        dispatch(userActions.allowLeavePage());
        calendarService.readLocalHolidaybyBranch(branch)
            .then(
                HolidaybyBranch => {
                    dispatch(success(HolidaybyBranch));
                    dispatch(calendarFetched());
                },
                error => {
                    dispatch(calendarFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(HolidaybyBranch) { return { type: calendarConstants.GET_LOCAL_HOLIDAY_BY_BRANCH, HolidaybyBranch } }
}
function getAllHoliday(branch) {
    return dispatch => {
        dispatch(calendarFetching());
        dispatch(userActions.allowLeavePage());
        calendarService.getAllHoliday(branch)
            .then(
                allHoliday => {
                    dispatch(success(allHoliday));
                    dispatch(calendarFetched());
                },
                error => {
                    dispatch(calendarFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(allHoliday) { return { type: calendarConstants.GET_ALL_HOLIDAYS, allHoliday } }
}
function getHoliday(id) {
    return dispatch => {
        dispatch(calendarFetching());
        dispatch(userActions.allowLeavePage());
        calendarService.getHoliday(id)
            .then(
                holidayById => {
                    dispatch(success(holidayById));
                    dispatch(calendarFetched());
                },
                error => {
                    dispatch(calendarFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(holidayById) { return { type: calendarConstants.GET_HOLIDAY_BY_ID, holidayById } }
}
function getAllWorkingDays(branch) {
    return dispatch => {
        dispatch(calendarFetching());
        dispatch(userActions.allowLeavePage());
        calendarService.getAllWorkingDays(branch)
            .then(
                allWorkDay => {
                    if (allWorkDay.length > 0) {
                        dispatch(success(allWorkDay));
                        dispatch(calendarFetched());
                    } else {
                        dispatch(calendarFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(calendarFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(allWorkDay) { return { type: calendarConstants.GET_ALL_WORKING_DAYS, allWorkDay } }
}
function getWorkingDayByBranch(branch) {
    return dispatch => {
        dispatch(calendarFetching());
        dispatch(userActions.allowLeavePage());
        calendarService.getWorkingDayByBranch(branch)
            .then(
                workDayByBranch => {
                    dispatch(success(workDayByBranch));
                    dispatch(calendarFetched());
                },
                error => {
                    dispatch(calendarFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(workDayByBranch) { return { type: calendarConstants.GET_WORK_DAY_BY_BRANCH, workDayByBranch } }
}
function createHoliday(payload) {
    return dispatch => {
        dispatch(calendarSubmitting());
        dispatch(userActions.notallowLeavePage());
        calendarService.createHoliday(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.success('Holiday added successfully'))
                    window.location.href = '/master_data/holidays';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function createWorkDays(payload) {
    return dispatch => {
        dispatch(calendarSubmitting());
        dispatch(userActions.notallowLeavePage());
        calendarService.createWorkDays(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.success('Work Schedule added successfully'))
                    window.location.href = '/master_data/work_schedule';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateHoliday(payload, id) {
    return dispatch => {
        dispatch(calendarSubmitting());
        dispatch(userActions.notallowLeavePage());
        calendarService.updateHoliday(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.success('Holiday updated successfully'))
                    window.location.href = '/master_data/holidays';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateWorkingDays(payload) {
    return dispatch => {
        dispatch(calendarSubmitting());
        dispatch(userActions.notallowLeavePage());
        calendarService.updateWorkingDays(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.success('Work Schedule updated successfully'))
                    window.location.href = '/master_data/work_schedule';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(calendarSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteHoliday(type, id, branch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        calendarService.deleteHoliday(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Holiday deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/holidays';
                            break;
                        default:
                            dispatch(getAllHoliday(branch));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteWorkingDays(type, id, branch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        calendarService.deleteWorkingDays(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Work Schedule deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/work_schedule';
                            break;
                        default:
                            dispatch(getAllWorkingDays(branch));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

